import React from "react";
import styles from './DeviceDetail.module.css';

const renderDirectionSVG = (directionsParam) => {
  const directions = Array.isArray(directionsParam)
    ? directionsParam
    : (typeof directionsParam === 'string' && directionsParam.length > 0
        ? directionsParam.split('-')
        : []);
  // Chỉ thẳng
  if (directions.length === 1 && directions[0] === 'up') {
    return (
      <img src="/static/icon-direction/up.svg" width="24" height="24" alt="up" />
    );
  }
    // Chỉ dưới
  if (directions.length === 1 && directions[0] === 'down') {
    return (
      <img src="/static/icon-direction/down.svg" width="24" height="24" alt="down" />
    );
 }
  // Chỉ phải
  if (directions.length === 1 && directions[0] === 'right') {
    return (
      <img src="/static/icon-direction/right.svg" width="24" height="24" alt="right" />
    );
  }
  // Chỉ trái
  if (directions.length === 1 && directions[0] === 'left') {
    return (
      <img src="/static/icon-direction/left.svg" width="24" height="24" alt="left" />
    );
  }
  // Thẳng + phải
  if (directions.includes('up') && directions.includes('right')) {
    return (
      <img src="/static/icon-direction/up-right.svg" width="24" height="24" alt="up-right" />
    );
  }
  // Thẳng + trái
  if (directions.includes('up') && directions.includes('left')) {
    console.log('Rendering up-left direction');
    return (
        <img src="/static/icon-direction/up-left.svg" width="24" height="24" alt="up-left" />
    );
  }
  // Dưới + phải
  if (directions.includes('down') && directions.includes('right')) {
    return (
      <img src="/static/icon-direction/down-right.svg" width="24" height="24" alt="down-right" />
    );
  }
    // Dưới + trái
    if (directions.includes('down') && directions.includes('left')) {
    return (
      <img src="/static/icon-direction/down-left.svg" width="24" height="24" alt="down-left" />
    );
    }
    // Ngược + Trái
    if (directions.includes('left') && directions.includes('reversed')) {
        return (
            <img src="/static/icon-direction/left-reverser.svg" width="24" height="24" alt="left-reversed" />
        );
    }
    // Ngược + Phải
    if (directions.includes('right') && directions.includes('reversed')) {
        return (
            <img src="/static/icon-direction/right-reverser.svg" width="24" height="24" alt="right-reversed" />
        );
    }
 return (
    <span style={{ color: 'red' }}></span>
);
};

const DeviceDetail = ({ 
    device, 
    isSelected, 
    onSelect, 
    onEdit, 
    handleDelete,
    onUpdateDevice 
}) => {
    const [isUpdating, setIsUpdating] = React.useState(false);
    const [localDevice, setLocalDevice] = React.useState(device);
    const [isScrolling, setIsScrolling] = React.useState(false);

    React.useEffect(() => {
        setLocalDevice(device);
    }, [device]);

    React.useEffect(() => {
        let scrollTimeout;
        const handleScroll = () => {
            setIsScrolling(true);
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
            setIsScrolling(false);
            }, 100); // sau 100ms không scroll thì coi là dừng
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
        }, []);

    if (!localDevice) {
        return <div className={styles.loading}>Loading device...</div>;
    }

    const getStatusIcon = (status) => {
        switch(status) {
            case 'green' :
                return '🟢';
            case 'red':
                return '🔴';
            case 'yellow':
                return '🟡';
            case 'blinking':
                return '🔄';
            case 'on':
                return '💡';
            case 'off':
                return '🔌';
            default:
                return '⚫';
        }
    };

    const getTypeIcon = (type, directionDisplay) => {
        if (type === 'light') return '💡';
        return (
            <span style={{ display: 'inline-flex', gap: 4 }}>
                {renderDirectionSVG(directionDisplay)}
            </span>
        );
    };

    const getNextStatus = (currentStatus, type) => {
        if (type === 'light') {
            return currentStatus === 'on' ? 'off' : 'on';
        } else if (type === 'signal') {
            switch(currentStatus) {
                case 'off':
                    return 'green';
                case 'green':
                    return 'yellow';
                case 'yellow':
                    return 'red';
                case 'red':
                    return 'green';
                default:
                    return 'off';
            }
        }
        return currentStatus;
    };

    const handleCardClick = () => {
        if (onSelect) {
            onSelect();
        }
    };

    const handleCardHover = () => {
        if (!isScrolling && onSelect) {
            onSelect();
        }
    };

    const handleStatusToggle = async (e) => {
        e.stopPropagation(); // Prevent card selection when clicking status
        if (isUpdating || !onUpdateDevice) return;

        try {
            setIsUpdating(true);
            const newStatus = getNextStatus(localDevice.status, localDevice.type);
            
            const updatedDevice = await onUpdateDevice(localDevice._id, {
                ...localDevice,
                status: newStatus
            });

            // Update local state if needed
            if (!updatedDevice) {
                setLocalDevice(prev => ({ ...prev, status: newStatus }));
            }
        } catch (error) {
            console.error('Error toggling device status:', error);
            alert('Failed to toggle device status. Please try again.');
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <div 
            onClick={handleCardClick}
            onMouseEnter={handleCardHover}
            className={`${styles.deviceDetail} ${isSelected ? `${styles.deviceDetail} ${styles.selected}` : ''}`}
            style={{ cursor: onSelect ? 'pointer' : 'default' }}
        >
            <div className={styles.deviceHeader}>
                <div className={styles.deviceInfo}>
                    <span className={styles.typeIcon}>{getTypeIcon(localDevice.type, localDevice.directionDisplay)}</span>
                    <div>
                        <h3 className={styles.deviceName}>{localDevice.name}</h3>
                        <span className={styles.deviceType}>{localDevice.type.toUpperCase()}</span>
                    </div>
                </div>
                <button 
                    className={`${styles.statusBadge} ${styles.toggleable} ${isUpdating ? styles.updating : ''}`}
                    onClick={handleStatusToggle}
                    disabled={isUpdating}
                    title={`Click to change ${localDevice.type} status`}
                >
                    <span className={styles.statusIcon}>{getStatusIcon(localDevice.status)}</span>
                    <span className={styles.statusText}>
                        {isUpdating ? 'Updating...' : localDevice.status}
                    </span>
                </button>
            </div>

            <div className={styles.deviceBody}>
                <div className={styles.infoGrid}>
                    <div className={styles.infoItem}>
                        <span className={styles.infoLabel}>Position</span>
                        <span className={styles.infoValue}>
                            X: {localDevice.position?.x || 0}, Y: {localDevice.position?.y || 0}
                        </span>
                    </div>
                    
                    {localDevice.type === 'light' && localDevice.brightness !== undefined && (
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Brightness</span>
                            <div className={styles.brightnessContainer}>
                                <span className={styles.infoValue}>{localDevice.brightness}%</span>
                                <div className={styles.brightnessBar}>
                                    <div 
                                        className={styles.brightnessFill}
                                        style={{ width: `${localDevice.brightness}%` }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    )}
                    
                    {localDevice.createdAt && (
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Created</span>
                            <span className={styles.infoValue}>
                                {new Date(localDevice.createdAt).toLocaleDateString()}
                            </span>
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.deviceActions}>
                <button 
                    className={styles.editButton}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (onEdit) {
                            onEdit(localDevice);
                        }
                    }}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                    Edit
                </button>
                <button 
                    className={styles.deleteButton}
                    onClick={(e) => {
                        if (handleDelete) {
                            if (window.confirm(`Are you sure you want to delete device ${localDevice.name}?`)) {
                                e.stopPropagation();
                                handleDelete(localDevice._id);
                            }
                        }
                    }}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="3,6 5,6 21,6"/>
                        <path d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v2"/>
                        <line x1="10" y1="11" x2="10" y2="17"/>
                        <line x1="14" y1="11" x2="14" y2="17"/>
                    </svg>
                    Delete
                </button>
            </div>
        </div>
    );
}

export default DeviceDetail;